<script>
	import { show_sidebar, active_breadcrumb } from '../../app-store';
	import LegacyComponentWrapper from '../../frame-components/legacy-component-wrapper.svelte';

	export let params;

	let legacy_component = {
		id: "article-content",
		popover_allow_list: {},
		screen_container_el: null,
		editors: [],
		popover: null,
		_create_error_alert_el: function (message) {
			return tag.article(
				{ class: "animate-in m-3" },
				tag.div({ class: "project-item-body" }, [
					tag.div({ class: "alert-title fw-bold"}, "Error"),
					tag.div({ class: "alert-message" }, message)
				])
			);
		},
		add_comment: function (btn_el) {
			// See popover content in _listen_for_selection
			const comment_id = "comment-" + Math.random().toString(36).substring(2, 9);
			const comment_el = btn_el.parentElement.querySelector("#comment");
			const comment = comment_el.value;
			if (!comment) {
				app.toast_msg.show("Please enter a comment");
				return;
			}
			let last_editor = this.editors[this.editors.length - 1]
			const selected_text_el = btn_el.parentElement.querySelector(".selected-text");
			const selected_text = selected_text_el.textContent;
			const card = this._create_comment_card({
				id: comment_id,
				comment_ref: selected_text,
				comment: comment,
				onremove: (id) => {
					last_editor.comments = last_editor.comments.filter((c) => c.id != id);
					card.el.remove();
					if (last_editor.comments.length === 0) {
						last_editor.btn_submit_comments_el.disabled = true;
						last_editor.comment_form.container_el.classList.remove("hidden");
						last_editor.comment_divider_el.classList.remove("hidden");
					}
				}
			});
			last_editor.comment_container_el.appendChild(card.el);
			this.popover.dispose();
			last_editor.comments.push({ id: comment_id, text: selected_text, feedback: comment, el: card.el})
			last_editor.btn_submit_comments_el.disabled = false;
			last_editor.comment_form.container_el.classList.add("hidden");
			last_editor.comment_divider_el.classList.add("hidden");
		},
		_set_editor_font_size: function (editor_el, multiplier) {
			const base_font_size = 14;
			const h1_font_size = 24;
			const h2_font_size = 20;
			const h3_font_size = 18;
			const h4_font_size = 16;
			const h5_font_size = 14;

			editor_el.style.setProperty('--editor-base-font-size', `${base_font_size * multiplier}px`);
			editor_el.style.setProperty('--editor-h1-font-size', `${h1_font_size * multiplier}px`);
			editor_el.style.setProperty('--editor-h2-font-size', `${h2_font_size * multiplier}px`);
			editor_el.style.setProperty('--editor-h3-font-size', `${h3_font_size * multiplier}px`);
			editor_el.style.setProperty('--editor-h4-font-size', `${h4_font_size * multiplier}px`);
			editor_el.style.setProperty('--editor-h5-font-size', `${h5_font_size * multiplier}px`);
		},
		_create_font_size_control: function ({ oninput, onchange, value }) {
			const el = tag.div({ class: "font-size-control mb-3" }, [
				tag.label({ for: "font-size-range", class: "text-nowrap d-block"}, "Font Size"),
				tag.div({ class: "d-flex align-items-center gap-1"}, [
					tag.span({ class: "badge text-bg-secondary small"}, "Min"),
					tag.input({ type: "range", class: "form-range field-range", value: value, id: "font-size-range", min: "1", max: "3", step: "0.1", value: "1", oninput: oninput, onchange: onchange }),
					tag.span({ class: "badge text-bg-secondary small"}, "Max"),
				])
			]);
			return {
				el,
				set_value: (value) => {
					el.querySelector("#font-size-range").value = value;
				}
			}
		},
		_create_comment_card: function ({id, comment_ref, comment, onremove }) {
			const card_el = tag.div({class: "card comment-card" },
				[
					tag.div({ class: "comment-card-header"},
						tag.button({ type: "button", class: "btn btn-comment-close btn-light btn-sm", onclick: () => {
							if (typeof onremove === "function") {
								onremove(id);
							}
						}},
							tag.img({src: "./img/close-line.svg", width: 20, height: 20})
						)
					),
					tag.div({ class: "card-body"}, [
						tag.div({class: "comment-ref"}, comment_ref),
						tag.div({class: "comment-text py-3"}, comment)
					])
				]
			)
			return {
				el: card_el
			}
		},
		_listen_for_selection: function (editor_content_el) {
			const editor_content_children_els = editor_content_el.children;
			for (const section_el of editor_content_children_els) {
				section_el.addEventListener("click", () => {
					const selected_text = section_el.textContent.trim();
					if (selected_text) {
						// Remove any popover if any
						const parent_editor_el = editor_content_el.parentElement;
						const current_popover_els = parent_editor_el.querySelectorAll(".popover, .bs-popover");
						for (const curr_popover_el of current_popover_els) {
							curr_popover_el.remove();
						}
						const rect = section_el.getBoundingClientRect();
						const popover_el = tag.div({
							"data-bs-toggle": "popover",
							"data-bs-title": "Comment",
							class: "bs-popover"
						});
						parent_editor_el.appendChild(popover_el);
						const container_rect = parent_editor_el.getBoundingClientRect();
						popover_el.style.position = "absolute";
						popover_el.style.top = `${(rect.top - container_rect.top) + parent_editor_el.scrollTop + (rect.height / 2) }px`;
						popover_el.style.right = `${container_rect.right - rect.right}px`;

						this.popover = new bootstrap.Popover(popover_el, {
							container: ".editor-container .embla__slide",
							allowList: this.popover_allow_list,
							html: true,
							customClass: "user-select-none",
							placement: "right",
						});

						// workaround inside the workaround to remove the legacy app click event
						window.add_draft_comment = (btn_el) => {
							this.add_comment(btn_el);
						};
						this.popover.setContent({
							'.popover-header': `<div class="d-flex align-items-center justify-content-between">Comment <button onclick="this.closest('.popover').remove()" class="btn btn-sm small text-black btn-light remove-popover">&times;</button></div>`,
							'.popover-body': `<p class="selected-text text-muted small user-select-none text-truncate">${selected_text}</p>
												<textarea rows="10" class="form-control mb-2 user-select-none" id="comment"></textarea>
												<button class="btn btn-light text-black btn-sm user-select-none" onclick="window.add_draft_comment(this)">Add</button>`
						});
						this.popover.show();
					}
				});
			}

			document.addEventListener("click", (e) => {
				const parent_editor_el = editor_content_el.parentElement;
				const popover_el = parent_editor_el.querySelector(".popover");
				if (popover_el && !popover_el.contains(e.target) && !editor_content_el.contains(e.target)) {
					this.popover.dispose();
					popover_el.remove();
				}
			});
		},
		_create_editor_carousel: function (editors) {
			const container_el = tag.div({ class: "embla" }, [
				tag.div(
					{ class: "embla__container editor-content-wrapper" },
					editors.map((e) => {
						return tag.div({ class: "embla__slide" }, [e.el, e.comment_wrapper_el, e.bottom_bar.el]);
					})
				),
			]);
			return {
				container_el,
			};
		},
		_create_keyphrase_counter_group: function ({ title = "", keyword_nums, onitemclick }) {
			const dropup_button = tag.button(
				{
					type: "button",
					class: "btn btn-secondary dropdown-toggle text-white",
					"data-bs-toggle": "dropdown",
					"aria-expanded": "false",
				},
				title
			);

			const dropdown_menu = tag.div(
				{ class: "dropdown-menu" },
				keyword_nums.map((kn) => {
					return tag.button({ class: "dropdown-item d-flex gap-1 align-items-center", onclick: onitemclick }, [
						kn.keyword,
						tag.span({ class: "badge text-bg-secondary" }, kn.count),
					]);
				})
			);

			const dropup_group = tag.div({ class: "btn-group dropup" }, [dropup_button, dropdown_menu]);

			return {
				el: dropup_group,
			};
		},
		_count_word: function (md_content) {
			const plain_text_content = md_content.replace(/[*_`~#>-]/g, "");
			const regex = /\s+/gi;
			const words = plain_text_content.trim().replace(regex, " ").split(" ");
			return words.length;
		},
		_count_keyword: function (keyword, md_content) {
			const plain_text_content = md_content.replace(/[*_`~#>-]/g, "");
			const regex = new RegExp(keyword, "gi");
			const matches = plain_text_content.match(regex);
			return matches ? matches.length : 0;
		},
		_create_article_version: function () {
			const version_current_el = tag.div({ class: "article-version-current" });
			const version_total_el = tag.div({ class: "article-version-total" });
			const container_el = tag.div({ class: "article-version-container" }, [
				tag.span("Draft"),
				version_current_el,
				tag.span("of"),
				version_total_el,
			]);
			return {
				container_el,
				version_current_el,
				version_total_el,
				set_total_version: (total) => {
					version_total_el.textContent = total;
				},
				set_current_version: (current) => {
					version_current_el.textContent = current;
				},
			};
		},
		_create_bottom_bar: function ({ id, class: class_name }) {
			const el = tag.div({ id, class: class_name });
			return {
				el,
			};
		},
		_create_comment_form: function ({ onclick, classname }) {
			const id = Math.random().toString(36).substring(2, 9);
			const textarea_el = tag.textarea({
				type: "text",
				class: "form-control form-control-sm small mb-2",
				placeholder: "Share a suggestion or comment instantly",
				id: id,
			});
			const container_el = tag.div(
				{ class: classname },
				tag.div([
					textarea_el,
					tag.button(
						{
							class: "btn btn-primary w-100",
							type: "button",
							onclick: onclick,
						},
						"Submit"
					),
				])
			);
			return {
				container_el,
				get_value: () => {
					return textarea_el.value;
				},
				reset: () => {
					textarea_el.value = "";
				},
			};
		},
		_create_selected_article_card: function ({ id, title, url, content }) {
			const blog_thumbnail_el = tag.img({
				src: "",
				alt: "",
				class: "img blog-thumbnail",
				width: 260,
				height: 135,
			});
			const container_el = tag.div({ class: "blog-item", "data-article_id": id }, [
				tag.a({ class: "blog-link", href: url, target: "_blank" }, [
					blog_thumbnail_el,
					tag.h2({ class: "blog-title" }, title),
					tag.div({ class: "blog-description" }, tag.p(content)),
				]),
			]);

			return {
				container_el,
				blog_thumbnail_el,
			};
		},
		_create_other_article_card: function ({ id, title, url, description }) {
			const container_el = tag.div({ class: "other-article blog-item", "data-article_id": id }, [
				tag.a({ href: url, target: "_blank" }, [
					tag.div({ class: "blog-title" }, title),
					tag.div({ class: "blog-description" }, tag.p(description)),
				]),
			]);
			return {
				container_el,
			};
		},
		show: function () {
			document.getElementById(this.id).classList.remove("hidden");
		},
		hide: function () {
			document.getElementById(this.id).classList.add("hidden");
		},
		create_modal: function ({ title }) {
			const el = tag.div(
				{
					class: "modal fade",
					id: "article-content-modal",
					tabindex: "-1",
					"aria-labelledby": "modal-label",
					"aria-hidden": "true",
				},
				[
					tag.div({ class: "modal-dialog" }, [
						tag.div({ class: "modal-content" }, [
							tag.div({ class: "modal-header" }, [
								tag.h1({ class: "modal-title fs-5", id: "modal-label" }, title),
								tag.button({
									type: "button",
									class: "btn-close",
									"data-bs-dismiss": "modal",
									"aria-label": "Close",
								}),
							]),
							tag.div({ class: "modal-body" }, "..."),
							tag.div({ class: "modal-footer" }, [
								tag.button(
									{ type: "button", class: "btn btn-secondary", "data-bs-dismiss": "modal" },
									"Close"
								),
								tag.button({ type: "button", class: "btn btn-primary" }, "Save changes"),
							]),
						]),
					]),
				]
			);
			return {
				el,
				show: () => {
					const modal = new bootstrap.Modal(document.getElementById("article-content-modal"));
					modal.show();
				},
			};
		},
		onshow: async function (payload = {}) {
			const project_ref = params.project_ref;
			const refcode = params.draft_refcode;

			active_breadcrumb.set("breadcrumb-article-content")

			const observer = new IntersectionObserver(async (entries, observer) => {
				for (const entry of entries) {
					if (entry.isIntersecting) {
						const img_el = entry.target;
						const url = img_el.getAttribute("data-url");
						try {
							const { previewimg } = await app.lucep_ai.check_url_content(refcode, url);
							img_el.src = previewimg ? previewimg : "./img/noimage.png";
						} catch (error) {
							console.error("Error fetching image:", error);
							app.toast_msg.show("Error fetching image");
							img_el.src = "./img/noimage.png";
						}
						observer.unobserve(img_el);
					}
				}
			});

			const converter = new window.showdown.Converter({ noHeaderId: true, tables: true });

			try {
				app.body_spinner.add_to(document.body);
				const { status, draft } = await app.lucep_ai.get_draft(refcode);
				if (status !== "ok") {
					console.error("Error fetching draft:", error);
					toast_msg.show("Error fetching draft");
					return;
				}
				const selected_articles = draft.selected_articles;
				const recommended_articles = draft.recommended_articles;
				const suggested_contents = [draft.suggested_content];
				const keyphrases = draft.keyphrases;
				const competitor_urls = draft.competitor_content_urls || [];
				const selected_article_list_el = tag.div({ class: "selected-article-list" });
				const selected_article_title = tag.div({ class: "fs-5 py-3" }, "Selected Articles:");
				const selected_article_cards = [];

				selected_article_list_el.appendChild(selected_article_title);

				// Build selected articles
				if (Array.isArray(selected_articles) && selected_articles.length > 0) {
					for (const article of selected_articles) {
						const selected_article_card = this._create_selected_article_card({
							id: article.id,
							title: article.title,
							url: article.url,
							content: article.content,
						});
						const selected_article_el = selected_article_card.container_el;
						selected_article_list_el.appendChild(selected_article_el);
						const blog_thumbnail_el = selected_article_card.blog_thumbnail_el;
						blog_thumbnail_el.classList.add("loading");
						if (app.cache_imgs[article.url]) {
							blog_thumbnail_el.src = app.cache_imgs[article.url];
							blog_thumbnail_el.addEventListener("load", (e) =>
								blog_thumbnail_el.classList.remove("loading")
							);
						} else {
							blog_thumbnail_el.setAttribute("data-url", article.url);
						}
						selected_article_cards.push(selected_article_card);
					}
				}

				for (const card of selected_article_cards) {
					const blog_thumbnail_el = card.blog_thumbnail_el;
					selected_article_list_el.appendChild(card.container_el);
					observer.observe(blog_thumbnail_el);
				}

				// Build other articles
				const other_article_el = tag.details(
					{ class: "other-articles user-select-none" },
					tag.summary("Other Articles")
				);
				const other_articles = recommended_articles.filter((article, index) => {
					const selected_article_ids = selected_articles.map((article) => article.id);
					return !selected_article_ids.includes(index);
				});

				for (const article of other_articles) {
					const other_article_card = this._create_other_article_card({
						id: article.id,
						title: article.title,
						url: article.url,
						description: article.description,
					});
					other_article_el.appendChild(other_article_card.container_el);
				}

				selected_article_list_el.appendChild(other_article_el);

				// Build article version
				const article_version = this._create_article_version();
				article_version.set_total_version(suggested_contents.length);
				article_version.set_current_version(suggested_contents.length);

				const btn_prev_el = tag.button(
					{
						class: "btn btn-prev btn-primary",
					},
					tag.img({ src: "./img/arrow-left-s-line.svg", width: "16", height: "16" })
				);
				const btn_next_el = tag.button(
					{
						class: "btn btn-next btn-primary",
					},
					tag.img({ src: "./img/arrow-right-s-line.svg", width: "16", height: "16" })
				);
				const carousel_control_wrapper_el = tag.div({ class: "carousel-control-wrapper hidden" }, [
					btn_prev_el,
					article_version.container_el,
					btn_next_el,
				]);

				// Build editors
				this.editors = [];
				const editor_el = tag.div({ id: "blog-editor", class: "blog-editor editor-container" });
				const editor_el_title_container = tag.div(
					{
						class: "editor-title-container p-3",
					},
					[tag.div({ class: "fs-5" }, "Review Your Draft: "), carousel_control_wrapper_el]
				);

				for (const suggested_content of suggested_contents) {
					const content = JSON.parse(suggested_content.content);
					const version = suggested_content.version;
					const feedback = suggested_content.feedback;
					let comments = [];

					// Build editor content
					const content_html = converter.makeHtml(content.blog_post_markup);
					const editor_content_el = tag.div({ class: "editor-content paper-background" });
					editor_content_el.innerHTML = content_html;

					// Build keyphrase and word counter
					const keywords = keyphrases.map((k) => k.keyphrase);
					const keywords_count = keywords.map((keyword) => {
						const count = this._count_keyword(keyword, content.blog_post_markup);
						return { keyword, count };
					});
					const keyphrase_counter_group = this._create_keyphrase_counter_group({
						title: "Keyphrases",
						keyword_nums: keywords_count,
					});
					const word_counter_el = tag.div(
						{
							class: "word-counter badge text-bg-light border border-dark-subtle p-2 h-100 d-flex align-items-center",
						},
						tag.span(
							{ class: "p-1 fs-6 fw-medium" },
							"Word count: ",
							tag.span({ class: "word-count" }, this._count_word(content.blog_post_markup))
						)
					);
					const competitor_urls_el = tag.div({
						class: "competitor-urls d-flex gap-1 mb-3 flex-column",
					},
					tag.span({ class: "text-muted small" }, "Competitor URLs"),
					competitor_urls.map((url) => {
						return tag.a({ class: "badge text-bg-light border border-dark-subtle p-2 text-start text-truncate fw-semibold", href: url, target: "_blank" }, url)
					}));

					// Build bottom bar
					const bottom_bar = this._create_bottom_bar({
						id: "article-content-bottom-bar",
						class: "article-bottom-bar p-3"
					});
					bottom_bar.el.appendChild(
						tag.div({ class: "d-flex align-items-center gap-1 mb-2" }, [keyphrase_counter_group.el, word_counter_el ])
					);
					bottom_bar.el.appendChild(competitor_urls_el);

					// Build comment form and submit
					const btn_submit_comments_el = tag.button(
						{
							class: "btn btn-action rounded-pill mb-1 w-100 btn-primary",
							disabled: true,
							onclick: () => {
								const last_editor = this.editors[this.editors.length - 1];
								if (last_editor.comments.length === 0) {
									app.toast_msg.show("Please add a comment");
									return;
								}
								const comments = last_editor.comments.map((c) => {
									return {
										text: c.text,
										feedback: c.feedback,
									};
								});
								app.body_spinner.add_to(document.body);
								app.lucep_ai.update_draft_with_comments(refcode, version, comments, {
									onUpdate: (data) => {
										const status = data.status;
										app.body_spinner.set_message(status);
									},
									onFinished: () => {
										this.onshow();
										app.body_spinner.remove();
									}
								}).catch((error) => {
									console.error("Error updating draft with comments", error);
									app.toast_msg.show("Error updating draft with comments");
									if (error.status_code === 500) {
										app.chat_manager.send_alert(this._create_error_alert_el(error_msg.server_error(error.msg)));
									} else {
										app.chat_manager.send_alert(this._create_error_alert_el(error_msg.client_error(error.msg)));
									}
									app.body_spinner.remove();
								});
							}
						},
						[tag.img({ src: "./img/message-3-line.svg", width: "16", height: "16" }), "Submit Comments"]
					);

					// Build Comment Form
					const comment_container_el = tag.div({ class: "comment-container py-3" });
					const comment_form = this._create_comment_form({
						classname: "mt-3",
						onclick: () => {
							if (!comment_form.get_value()) {
								app.toast_msg.show("Please enter a comment");
								return;
							}
							app.body_spinner.add_to(document.body);
							app.lucep_ai.update_draft_with_comments(refcode, version, comment_form.get_value(), {
								onUpdate: (data) => {
									const status = data.status;
									app.body_spinner.set_message(status);
								},
								onFinished: () => {
									this.onshow();
									app.body_spinner.remove();
								}
							}).catch((error) => {
								console.error("Error updating draft with comments", error);
								app.toast_msg.show("Error updating draft with comments");
								if (error.status_code === 500) {
									app.chat_manager.send_alert(this._create_error_alert_el(error_msg.server_error(error.msg)));
								} else {
									app.chat_manager.send_alert(this._create_error_alert_el(error_msg.client_error(error.msg)));
								}
								app.body_spinner.remove();
							});
						}
					});

					const comment_wrapper_el = tag.div({ class: "comment-wrapper" });
					comment_wrapper_el.appendChild(btn_submit_comments_el);

					const comment_divider_el = tag.div({ class: "comment-divider d-flex align-items-center gap-1" }, [
						tag.span("OR "),
						tag.hr({ class: " w-100" }),
					]);

					comment_container_el.appendChild(tag.span({ class: "text-muted small" }, "Click on a section to add your comment."));
					comment_wrapper_el.append(comment_container_el, comment_divider_el, comment_form.container_el);

					this.editors.push({
						id: Math.random().toString(36).substring(2, 9),
						content: content,
						version: version,
						feedback: feedback,
						el: editor_content_el,
						content_html: content_html,
						keyphrase_counter_group: keyphrase_counter_group,
						word_counter_el: word_counter_el,
						bottom_bar,
						comment_wrapper_el,
						comment_container_el,
						comments,
						btn_submit_comments_el,
						comment_form,
						comment_divider_el
					});
				}

				// Attach comment selection to the last editor
				const last_editor = this.editors[this.editors.length - 1];
				this._listen_for_selection(last_editor.el);

				// Build slider
				const editor_carousel = this._create_editor_carousel(this.editors);
				const editor_embla_carousel = window.EmblaCarousel(editor_carousel.container_el, {
					loop: false,
					watchDrag: false,
				});

				btn_next_el.addEventListener("click", () => editor_embla_carousel.scrollNext());
				btn_prev_el.addEventListener("click", () => editor_embla_carousel.scrollPrev());

				editor_el.appendChild(editor_el_title_container);
				editor_el.appendChild(editor_carousel.container_el);

				// Build download and copy buttons
				const btn_copy_el = tag.button(
					{
						class: "btn btn-action rounded-pill mb-1 w-100 btn-primary",
						onclick: async () => {
							const selected_slide = editor_embla_carousel.selectedScrollSnap();
							const md_content = this.editors[selected_slide].content.blog_post_markup;
							const plain_text_content = md_content.replace(/[*_`~#>-]/g, "");
							try {
								await navigator.clipboard.writeText(plain_text_content);
								const btn_copy_el_content = btn_copy_el.innerHTML;
								btn_copy_el.innerHTML =
									"<span> <img src='./img/check-fill.svg' width=16 height=16 /> Copied!</span>";
								setTimeout(() => (btn_copy_el.innerHTML = btn_copy_el_content), 2000);
							} catch (err) {
								console.error("Could not copy text: ", err);
								app.toast_msg.show("Could not copy text. Please reload the page and try again.");
							}
						},
					},
					[tag.img({ src: "./img/file-copy-line.svg", width: "16", height: "16" }), "Copy to Clipboard"]
				);

				const btn_download_dropdown = window.create_dropdown({
					text: "Download",
					classnames: ["btn-action", "rounded-pill", "mb-1", "w-100", "btn-primary"],
					btn_classnames: ["btn-sm", "small"]
				});

				const btn_download_md_el = tag.button(
					{
						class: "btn btn-action rounded-pill mb-1 w-100 btn-primary text-white",
						onclick: () => {
							const selected_slide = editor_embla_carousel.selectedScrollSnap();
							const title = this.editors[selected_slide].content.title;
							const content_md = this.editors[selected_slide].content.blog_post_markup;
							const blob = new Blob([content_md], { type: "text/markdown" });
							const url = URL.createObjectURL(blob);
							const a = tag.a({ href: url, download: "article-" + title + ".md" });
							a.click();
							URL.revokeObjectURL(url);
						},
					},
					[tag.img({ src: "./img/markdown-line.svg", width: "16", height: "16" }), "Download as Markdown"]
				);

				const btn_download_html_el = tag.button(
					{
						class: "btn btn-action rounded-pill mb-2 w-100 btn-primary text-white",
						onclick: () => {
							const selected_slide = editor_embla_carousel.selectedScrollSnap();
							const title = this.editors[selected_slide].content.title;
							const content_ml = this.editors[selected_slide].content_html;
							const blob = new Blob([content_ml], { type: "text/html" });
							const url = URL.createObjectURL(blob);
							const a = tag.a({ href: url, download: "article-" + title + ".html" });
							a.click();
							URL.revokeObjectURL(url);
						},
					},
					[tag.img({ src: "./img/html5-line.svg", width: "16", height: "16" }), "Download as HTML"]
				);
				btn_download_dropdown.add_item(btn_download_md_el);
				btn_download_dropdown.add_item(btn_download_html_el);

				const btn_group = tag.div({ class: "flex-column w-100 mb-3" });
				btn_group.append(btn_copy_el, btn_download_dropdown.el);

				// Build screen
				this.screen_container_el.innerHTML = "";
				this.screen_container_el.appendChild(selected_article_list_el);
				this.screen_container_el.appendChild(editor_el);

				// Build font-size control
				let curr_editor_el = this.editors[editor_embla_carousel.selectedScrollSnap()].el;
				const saved_font_size_multiplier = app.storage.get("editor-font-size-multiplier") || 1;
				this._set_editor_font_size(curr_editor_el, saved_font_size_multiplier);
				const font_size_control = this._create_font_size_control({
					oninput: (e) => {
						const multiplier = e.target.value;
						curr_editor_el = this.editors[editor_embla_carousel.selectedScrollSnap()].el;
						const editor_content_el = curr_editor_el
						this._set_editor_font_size(editor_content_el, multiplier);
					},
					onchange: (e) => {
						app.storage.set("editor-font-size-multiplier", parseFloat(e.target.value));
					},
				});
				font_size_control.set_value(saved_font_size_multiplier);

				// Slider has been added to the DOM, so we can now initialize it
				editor_embla_carousel.on("init", (e) => {
					setTimeout(() => {
						e.scrollTo(this.editors.length);
						btn_next_el.disabled = e.canScrollNext() ? false : true;
						btn_prev_el.disabled = e.canScrollPrev() ? false : true;
					}, 100);
				});
				editor_embla_carousel.on("select", (e) => {
					const content_index = e.selectedScrollSnap();
					article_version.set_current_version(content_index + 1);
					btn_next_el.disabled = e.canScrollNext() ? false : true;
					btn_prev_el.disabled = e.canScrollPrev() ? false : true;
					let curr_editor_el = this.editors[content_index].el;
					const saved_font_size_multiplier = app.storage.get("editor-font-size-multiplier") || 1;
					this._set_editor_font_size(curr_editor_el, saved_font_size_multiplier);
					font_size_control.set_value(saved_font_size_multiplier);
				});

				app.chat_manager.clear();
				app.chat_manager.send_alert(btn_group);
				app.chat_manager.send_alert(font_size_control.el);
				app.chat_manager.send_ai_message("writer", "first_draft");
				// app.chat_manager.send_ai_message("reviewer", "chatbox_rewrite");
			} catch (error) {
				console.error("Something went wrong", error);
				app.toast_msg.show("Something went wrong");
				if (error.status_code === 500) {
					const error_alert_el = this._create_error_alert_el(error_msg.server_error(error.msg));
					this.screen_container_el.innerHTML = "";
					this.screen_container_el.appendChild(error_alert_el);
				} else {
					const error_alert_el = this._create_error_alert_el(error_msg.client_error(error.msg));
					this.screen_container_el.innerHTML = "";
					this.screen_container_el.appendChild(error_alert_el);
				}
			} finally {
				app.body_spinner.remove();
			}
		},
		init: function () {
			this.popover_allow_list =  bootstrap.Tooltip.Default.allowList;
			this.popover_allow_list.button = ["onclick"];
			this.popover_allow_list.textarea = [];
			this.screen_container_el = tag.div({ class: "action-area action-area-article-content" });
			return this.screen_container_el;
		},
	};

</script>

<LegacyComponentWrapper legacy_component={legacy_component} params={params} />
